exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-width[data-v-fa830dec] {\r\n    width: 70%;\n}\n.dialog-footer[data-v-fa830dec] {\r\n    margin-top: 20px;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align: center;\r\n        -ms-flex-align: center;\r\n            align-items: center;\n}\n.tree-container[data-v-fa830dec] {\r\n    border: 1px solid #EBEEF5;\r\n    padding: 20px 10px;\r\n    min-height: 400px;\r\n    overflow-y: scroll;\n}\r\n\r\n", ""]);

// exports
